import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import "./Styles.css";

import Grid from "./Grid";

const batImages = [
   {
      id: "uYpOYyJasfc",
      url: "https://tiendamic.com/gamification/2025/movies/game-concentrese-bob-esponja/assets/images/Movies_Q4_Bob_esponja_Juego_Concentrese_1.png",
      alt_description: "image-1",
   },
   {
      id: "uYpOYyJoñl",
      url: "https://tiendamic.com/gamification/2025/movies/game-concentrese-bob-esponja/assets/images/Movies_Q4_Bob_esponja_Juego_Concentrese_2.png",
      alt_description: "image-2",
   },
   {
      id: "uYpOYyJdkuk",
      url: "https://tiendamic.com/gamification/2025/movies/game-concentrese-bob-esponja/assets/images/Movies_Q4_Bob_esponja_Juego_Concentrese_3.png",
      alt_description: "image-3",
   },
   {
      id: "uYpOYyJdeve",
      url: "https://tiendamic.com/gamification/2025/movies/game-concentrese-bob-esponja/assets/images/Movies_Q4_Bob_esponja_Juego_Concentrese_4.png",
      alt_description: "image-4",
   },
   {
      id: "uYpOYydffh",
      url: "https://tiendamic.com/gamification/2025/movies/game-concentrese-bob-esponja/assets/images/Movies_Q4_Bob_esponja_Juego_Concentrese_5.png",
      alt_description: "image-5",
   },
   {
      id: "uYpOYyJdfhb",
      url: "https://tiendamic.com/gamification/2025/movies/game-concentrese-bob-esponja/assets/images/Movies_Q4_Bob_esponja_Juego_Concentrese_6.png",
      alt_description: "image-6",
   },
];

function App() {
   const [newGame, setNewGame] = useState(false);
   const [list, setList] = useState([]);
   const [visibleItems, setVisibleItems] = useState([]);
   const [finishedItems, setFinishedItems] = useState([]);
   const [winner, setWinner] = useState(false);

   const checkItems = (firstIndex, secondIndex) => {
      if (
         firstIndex !== secondIndex &&
         list[firstIndex].url === list[secondIndex].url
      ) {
         setFinishedItems([...finishedItems, firstIndex, secondIndex]);
      } else {
         setTimeout(() => {
            setVisibleItems([]);
         }, 600);
      }
   };

   useEffect(() => {
      // axios
      //   .get(
      //     "https://moviesshopco.vteximg.com.br/files/batman-game.json"
      //   )
      //   .then(res => {
      const newList = batImages.map((item) => {
         return {
            id: item.id,
            url: item.url,
            description: item.alt_description,
         };
      });
      setList(
         newList
            .concat(
               newList.map((item) => {
                  return {
                     ...item,
                     id: item.id + "1",
                  };
               })
            )
            .sort(() => {
               return 0.5 - Math.random();
            })
      );
      // });
   }, [newGame]);

   useEffect(() => {
      if (finishedItems.length > 0 && finishedItems.length === list.length) {
         setWinner(true);
      }
   }, [finishedItems]);

   return (
      <div className='x-flex-column'>
         {list.length === 0 ? (
            <div className='game-load-contain'>
               <Skeleton className='game-load' count={1} />
            </div>
         ) : (
            <div>
               <Grid
                  list={list}
                  visibleItems={visibleItems}
                  finishedItems={finishedItems}
                  winner={winner}
                  newGame={newGame}
                  checkItems={checkItems}
                  setNewGame={setNewGame}
                  setWinner={setWinner}
                  setVisibleItems={setVisibleItems}
                  setFinishedItems={setFinishedItems}
               />
            </div>
         )}
      </div>
   );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
